import React from "react";
import styles from "./AutumnSaleHero.module.scss";
import background from "images/heros/Autumn Sale/background.jpg";
import titleImage from "images/heros/Autumn Sale/text.png";
import cityImage from "images/heros/Autumn Sale/CityScape.png";
import { useNavigate } from 'react-router-dom';

import { getGameList } from "constants/GameListAdapter";
import MiniGameCard from "components/Heros/MiniGameCard/MiniGameCard";


const AutumnSaleHero = () => {
    const navigate = useNavigate();
    return (
        <div className={styles.stackedImagesContainer}>
            <img src={background} className={styles.bgImage} alt="Background" />
            <div className={styles.Games}>
                {
                    getGameList().filter(g => g.showInHero && g.status === "enabled").map(g => {
                        return <MiniGameCard game={g} key={g.gameId} showAddToCart={true} useOldPrice={true} buttonColor={"#ff9900"} />
                    })
                }
            </div>
            <img src={cityImage} className={styles.bottomImage} alt="City" />
            <img src={titleImage} className={styles.textImage} onClick={() => navigate("/shop")} alt="Sale Text" />
            {/*<h2 className={styles.title}> Super Summer Sale </h2>*/}

        </div>
    );
};

export default AutumnSaleHero;